// M-5: shared password policy — MUST stay in lockstep with
// `validate_password_strength` / `COMMON_WEAK_PASSWORDS` in
// /app/backend/server.py. If you change one side, change the other.

export const PASSWORD_RULES = [
  { key: "length", label: "At least 10 characters", test: (v) => (v || "").length >= 10 },
  { key: "upper",  label: "One uppercase letter (A-Z)", test: (v) => /[A-Z]/.test(v || "") },
  { key: "lower",  label: "One lowercase letter (a-z)", test: (v) => /[a-z]/.test(v || "") },
  { key: "digit",  label: "One number (0-9)", test: (v) => /\d/.test(v || "") },
  { key: "symbol", label: "One special character (e.g. !@#$%)", test: (v) => /[^A-Za-z0-9]/.test(v || "") },
];

export const COMMON_WEAK_PASSWORDS = new Set([
  "password", "password1", "password12", "password123", "password1234",
  "passw0rd", "passw0rd1", "p@ssw0rd", "p@ssword", "p@ssword1",
  // Post-strip variants (see server.py comment).
  "pssw0rd", "pssword", "pssword1", "psswrd",
  "12345678", "123456789", "1234567890", "qwerty123", "qwertyuiop",
  "letmein123", "welcome1", "welcome123", "iloveyou1", "abcd1234",
  "administrator", "admin1234", "admin@123", "changeme", "changeme1",
  "trustno1", "monkey123", "dragon123", "football1", "baseball1",
  "sunshine1", "master123", "shadow123", "superman1", "batman123",
  "starwars1", "princess1", "qwerty1234", "asdfghjkl1",
]);

// Returns null when the password satisfies the policy, otherwise a short
// human-readable reason string suitable for showing next to the field.
export function validatePasswordClient(pw) {
  if (!pw || typeof pw !== "string") return "Password is required.";
  if (pw.length < 10) return "Password must be at least 10 characters long.";
  if (pw.length > 128) return "Password must be 128 characters or fewer.";
  if (!/[A-Z]/.test(pw)) return "Password must include at least one uppercase letter.";
  if (!/[a-z]/.test(pw)) return "Password must include at least one lowercase letter.";
  if (!/\d/.test(pw)) return "Password must include at least one number.";
  if (!/[^A-Za-z0-9]/.test(pw)) return "Password must include at least one special character (e.g. !@#$%).";
  if (COMMON_WEAK_PASSWORDS.has(pw.toLowerCase())) return "This password is too common. Please choose something more unique.";
  // Also block common stems dressed up with punctuation (e.g. "Password123!").
  const stem = pw.toLowerCase().replace(/[^a-z0-9]/g, "");
  if (stem && COMMON_WEAK_PASSWORDS.has(stem)) return "This password is too common. Please choose something more unique.";
  return null;
}
